'use client';

import React, { useEffect, useState } from 'react';
import EditProfileLocationStep from './EditProfileLocationStep';
import EditProfileStep from './EditProfileStep';
import EditProfileContactStep from './EditProfileContactStep';
import EditProfileAboutStep from './EditProfileAboutStep';
import EditProfileSkillsStep from './EditProfileSkillsStep';
import EditProfileCausesStep from './EditProfileCausesStep';
import EditProfilePrivacyStep from './EditProfilePrivacyStep';
import EditProfileNpoStep from './EditProfileNpoStep';
import EditProfileCommunityStep from './EditProfileCommunityStep';
import { updateUserProfile } from 'stores/userActions';
import { isEmpty } from 'lodash-es';
import { authorizedServerFetch, revalidatePage } from 'actions/server.actions';
import EditProfileNotificationsStep from './EditProfileNotificationsStep';

function EditProfileForm(props) {
  const {
    onSubmit,
    userProfile,
    header,
    updateHeader,
    saving,
    updateSaving,
    closeModal,
  } = props;
  const [step, setStep] = useState(header || 'Profile Information');
  const [formData, setFormData] = useState({});
  const [selectedCauses, setSelectedCauses] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedNpos, setSelectedNpos] = useState([]);
  const [selectedCommunitites, setSelectedCommunitites] = useState([]);
  const userId = userProfile?.id;

  const handleCauseSubmission = async (causes) => {
    try {
      if (!isEmpty(causes)) {
        updateSaving(true);
        const payload = {
          causeIds: causes.map((cause) => cause.id),
        };
        const formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        const { data, ok } = await authorizedServerFetch(
          `/users/${userId}/causes`,
          {
            method: 'PUT',
            body: formData,
          },
        );
        console.log('data', data);
        if (ok) {
          await updateUserProfile({ causes: data });
          // revalidatePage('/profile/me');
          updateHeader('Causes Supported');
        }
      }
    } catch (err) {
      console.log('errr', err);
    } finally {
      updateSaving(false);
    }
  };

  const handleSkillSubmission = async (skills) => {
    try {
      if (!isEmpty(skills)) {
        updateSaving(true);
        const payload = {
          skillIds: skills.map((skill) => skill.id),
        };
        const formData = new FormData();
        formData.append('data', JSON.stringify(payload));

        const { data, ok } = await authorizedServerFetch(
          `/users/${userId}/skills`,
          {
            method: 'PUT',
            body: formData,
          },
        );
        console.log('data', data);
        if (ok) {
          await updateUserProfile({ skills: data });
          // revalidatePage('/profile/me');
          updateHeader('Skills');
        }
      }
    } catch (err) {
      console.log('err', err);
    } finally {
      updateSaving(false);
    }
  };

  const handleFormSubmit = (data, type) => {
    // updateHeader(step);
    let payload = {};
    switch (type) {
      case 'Profile Information':
        payload = {
          ...formData,
          ...data,
        };
        setFormData({});
        onSubmit(payload, 'Profile Information');
        // setStep('Contact Information');
        break;
      case 'Contact Information':
        payload = {
          ...formData,
          ...data,
        };
        setFormData({});
        onSubmit(payload, 'Contact Information');
        // setStep('About');
        break;
      case 'About':
        payload = {
          ...formData,
          ...data,
        };
        setFormData({});
        onSubmit(payload, 'About');
        // setStep('Skills');
        break;
      case 'Skills':
        setFormData({
          ...formData,
          ...data,
        });
        setFormData({});
        handleSkillSubmission(selectedSkills);
        // setStep('Causes Supported');
        break;
      case 'Causes Supported':
        setFormData({
          ...formData,
          ...data,
        });
        setFormData({});
        handleCauseSubmission(selectedCauses);
        // setStep('NPO Supported');
        break;
      case 'Nonprofits Supported':
        setFormData({
          ...formData,
          ...data,
        });
        setFormData({});
        // setTimeout(() => {
        //   closeModal('success', true);
        //   revalidatePage('/profile/me');
        // }, 3000);
        // window.location.reload();
        // setStep('Privacy Settings');
        break;
      case 'Privacy Settings':
        payload = {
          ...formData,
          ...data,
        };
        setFormData({});
        onSubmit(payload, 'Privacy Settings');
        break;
      case 'Notifications':
        payload = {
          ...formData,
          ...data,
        };
        setFormData({});
        onSubmit(payload, 'Notifications');
        break;
      default:
        break;
    }
  };

  const handleBack = () => {
    switch (step) {
      case 'Contact Information':
        setStep('Profile Information');
        updateHeader('Profile Information');
        break;
      case 'About':
        setStep('Contact Information');
        updateHeader('Contact Information');
        break;
      case 'Skills':
        setStep('About');
        updateHeader('About');
        break;
      case 'Causes Supported':
        setStep('Skills');
        updateHeader('Skills');
        break;
      case 'Nonprofits Supported':
        setStep('Causes Supported');
        updateHeader('Causes Supported');
        break;
      case 'Privacy Settings':
        setStep('Nonprofits Supported');
        updateHeader('Nonprofits Supported');
        break;
      case 'Notifications':
        setStep('Privacy Settings');
        updateHeader('Privacy Settings');
        break;
    }
  };

  const handleNext = () => {
    switch (step) {
      case 'Profile Information':
        setStep('Contact Information');
        updateHeader('Contact Information');
        break;
      case 'Contact Information':
        setStep('About');
        updateHeader('About');
        break;
      case 'About':
        setStep('Skills');
        updateHeader('Skills');
        break;
      case 'Skills':
        setStep('Causes Supported');
        updateHeader('Causes Supported');
        break;
      case 'Causes Supported':
        setStep('Nonprofits Supported');
        updateHeader('Nonprofits Supported');
        break;
      case 'Nonprofits Supported':
        setStep('Privacy Settings');
        updateHeader('Privacy Settings');
        break;
      case 'Privacy Settings':
        setStep('Notifications');
        updateHeader('Notifications');
        break;
    }
  };

  const handleCauseChange = (causes) => {
    setSelectedCauses(causes);
  };

  const handleSkillChange = (skills) => {
    setSelectedSkills(skills);
  };

  const handleNpoChange = (npo) => {
    setSelectedNpos(npo);
  };

  useEffect(() => {
    setStep(header);
  }, [header, updateHeader]);

  if (step === 'Profile Information') {
    return (
      <EditProfileStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        saving={saving}
      />
    );
  }
  if (step === 'Contact Information') {
    return (
      <EditProfileContactStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        saving={saving}
      />
    );
  }
  if (step === 'About') {
    return (
      <EditProfileAboutStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        saving={saving}
      />
    );
  }
  if (step === 'Skills') {
    return (
      <EditProfileSkillsStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        onChange={handleSkillChange}
        saving={saving}
      />
    );
  }
  if (step === 'Causes Supported') {
    return (
      <EditProfileCausesStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        onChange={handleCauseChange}
        saving={saving}
      />
    );
  }
  if (step === 'Nonprofits Supported') {
    return (
      <EditProfileNpoStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        onChange={handleNpoChange}
        saving={saving}
      />
    );
  }
  if (step === 'Privacy Settings') {
    return (
      <EditProfilePrivacyStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        saving={saving}
      />
    );
  }
  if (step === 'Notifications') {
    return (
      <EditProfileNotificationsStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        onNext={handleNext}
        formData={formData}
        userProfile={userProfile}
        saving={saving}
      />
    );
  }
  return null;
}

export default EditProfileForm;
